import { render, staticRenderFns } from "./AlertsSEN.vue?vue&type=template&id=3ecf43df&scoped=true"
import script from "./AlertsSEN.vue?vue&type=script&lang=js"
export * from "./AlertsSEN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf43df",
  null
  
)

export default component.exports